export async function mapWithConcurrency<T, R>(
  items: T[],
  concurrency: number,
  mapper: (item: T, index: number) => Promise<R>
): Promise<R[]> {
  const results = Array.from<R>({ length: items.length });
  let nextIndex = 0;
  const worker = async (): Promise<void> => {
    if (nextIndex >= items.length) return;
    const index = nextIndex;
    nextIndex += 1;
    results[index] = await mapper(items[index], index);
    return worker();
  };
  const workerCount = Math.max(1, Math.min(concurrency, items.length));
  await Promise.all(Array.from({ length: workerCount }, () => worker()));
  return results;
}
